<template>
    <div 
      class="group relative py-2" 
      :class="{ 'cursor-pointer': showTooltip && data && hasTime }"
    >
      <div 
        class="parent relative"
        @mouseover="showTooltip && (isTooltipVisible = true)" 
        @mouseout="isTooltipVisible = false"
      >
        {{ formattedDate }}
        
        <div 
          v-if="showTooltip && data && hasTime" 
          class="absolute right-full group-hover:visible w-20 bg-black text-white px-2 mb-3 py-2 text-sm rounded-md transition-opacity shadow-sm z-10" 
          v-show="isTooltipVisible" 
          style="width: 90px; top:-5px; right: 110%;"
        >
          <p class="leading-2 text-white">{{ formattedTime }}</p>
          <svg 
            class="absolute z-10 right-0 top-3.5" 
            style="right: -13px; transform: rotate(-90deg);" 
            width="16" 
            height="10" 
            viewBox="0 0 16 10" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 10L0 0L16 1.41326e-06L8 10Z" fill="#3a3a3a" class="bg-black"/>
          </svg>
        </div>
      </div>
    </div>
  </template>
  

  <script>
  import moment from 'moment';
  export default {
    name: "DateTooltip",
    props: {
      data: {
        type: String,
        default: ''
      },
      showTooltip: {
        type: Boolean,
        default: true
      },
      dateFormat: {
        type: String,
        default: 'MMMM D, YYYY'  // e.g., "August 1, 1984"
      },
      timeFormat: {
        type: String,
        default: 'h:mm A'  // e.g., "12:00 PM"
      }
    },
    data: () => ({
      isTooltipVisible: false
    }),
    computed: {
      momentDate() {
        if (!this.data) return null;
        
        // Try parsing with different ISO formats
        const formats = [
          'YYYY-MM-DD',           // date only
          'YYYY-MM-DDTHH:mm:ss', // date + time
          'YYYY-MM-DDTHH:mm:ssZ', // date + time + timezone
          'MM-DD-YYYY h:mm a',    // date + time + AM/PM
          'MM-DD-YYYY',           // date only in UI format
          moment.ISO_8601        // fallback to all ISO 8601 formats
        ];
        
        const parsed = moment(this.data, formats, true); // strict parsing
        return parsed.isValid() ? parsed : null;
      },
      hasTime() {
        if (!this.momentDate) return false;
        
        // First check if the original string contains time information
        const hasTimeString = /T\d{2}:\d{2}/.test(this.data);
        
        // Then verify the parsed moment object has non-zero time components
        const hasNonZeroTime = this.momentDate.hours() !== 0 || 
                              this.momentDate.minutes() !== 0 || 
                              this.momentDate.seconds() !== 0;
                              
        return hasTimeString || hasNonZeroTime;
      },
      formattedTime() {
        if (!this.momentDate || !this.hasTime) return '';
        return this.momentDate.format(this.timeFormat);
      },
      formattedDate() {
        if (!this.momentDate) return '--';
        return this.momentDate.format(this.dateFormat);
      }
    }
  };
  </script>
  <style scoped lang="scss">
  span.label {
    text-transform: capitalize;
    cursor: help;
  }
  </style>
